export const productsEndpoints = {
  getProductsBySupplierId: { method: 'get', path: '/' },
  getProduct: { method: 'get', path: '/{id}' },
  insertProduct: { method: 'post', path: '/insert' },
  updateProduct: { method: 'post', path: '/{id}/update' },
  searchProducts: { method: 'get', path: '/search' },
  getGlobalProductsBySupplier: { method: 'get', path: '/global-products-by-supplier' },
  archiveProduct: { method: 'post', path: '/archive' },
  unarchiveProduct: { method: 'post', path: '/unarchive' },
  listProductCatalogueEntries: { method: 'get', path: '/catalogue-entries' },
  insertProductCatalogueEntry: { method: 'post', path: '/catalogue-entries/insert' },
  bulkUploadProductCatalogueEntries: { method: 'post', path: '/catalogue-entries/bulk-upload' },
  updateProductBrand: { method: 'post', path: '/brands/{orgProductsAndServicesBrandId}/update' }, // Note: consider moving to a "Brand" Api in future
  deleteProductBrand: { method: 'post', path: '/brands/{orgProductsAndServicesBrandId}/delete' }, // Note: consider moving to a "Brand" Api in future
  listProductBrands: { method: 'get', path: '/brands' }, // Note: consider moving to a "Brand" Api in future
  listProductBrandCandidates: { method: 'get', path: '/brands/candidates' }, // Note: consider moving to a "Brand" Api in future
  listOrgSupplierBrands: { method: 'get', path: '/brands/org-suppliers' }, // Note: consider moving to a "Brand" Api in future
  linkOrgDataToBrands: { method: 'post', path: '/brands/link-org-data' }, // Note: consider moving to a "Brand" Api in future
  getOrgSupplierAndProductCsvData: { method: 'get', path: '/brands/get-org-csv-data' }, // Note: consider moving to a "Brand" Api in future
  initSupplierProductLinkingUpload: { method: 'post', path: '/brands/init-linking-upload' }, // Note: consider moving to a "Brand" Api in future
  getProductEngagements: { method: 'get', path: '/{id}/engagements' },
  // Categories
  listProductSupplierCategories: { method: 'get', path: '/brands/categories' },
  syncProductSupplierCategories: { method: 'post', path: '/brands/categories/sync' },
  updateProductBrandCategories: { method: 'post', path: '/brands/{orgProductsAndServicesBrandId}/categories' },
  productCapabilitySearch: { method: 'get', path: '/recommendations/capability' },
  productAlternativeSearch: { method: 'post', path: '/recommendations/alternatives' },
  productAlternativeFeedback: { method: 'post', path: '/recommendations/alternatives/feedback' },
  listProducts: { method: 'post', path: '/list' },
} as const
